module.exports = __webpack_public_path__ + "img/487FC9_A8E7F8_88CCF2_70AFDE-256px.775818c3.png";